(() => {
  const ROOT_SELECTOR = '[data-quote-booking]';

  function syncPageClass() {
    document.body?.classList.toggle('quote-booking-page', Boolean(document.querySelector(ROOT_SELECTOR)));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPageClass, { once: true });
  } else {
    syncPageClass();
  }

  document.addEventListener('shopify:section:load', syncPageClass);
  document.addEventListener('shopify:section:unload', () => window.requestAnimationFrame(syncPageClass));
})();
